import React from "react";

export default function Page404() {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-[#F94C10]">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Page introuvable
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          Désolé, nous n&apos;avons pas trouvé la page que vous recherchée.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <a
            href="/"
            className="rounded-md bg-[#F94C10] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#F94C10]/80 duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#F94C10]/100"
          >
            Retour à l&apos;accueil
          </a>
          <a href="#" className="text-sm font-semibold text-gray-900">
            nous contacter <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </main>
  );
}
